import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './seed_dummy_data.js';

// Production Log Stripper: Purge debug logs to prevent credential / PII leaks in DevTools
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  process.env.NODE_ENV === 'development' ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
